import { useMicrocopy } from "@/lib/contentful/microcopy/microcopy-context";
import { Text } from "@project/ui";

export const DriverOverTitleComponent = () => {
    const { get: getMicrocopy } = useMicrocopy();

    return (
        <Text size="caption" color="grey600">
            {getMicrocopy("pageDriverPage", "label.driverName")}
        </Text>
    );
};
